import { USER_ROLE } from '../domain/enums/user.enums'

export const COMPONENTS_ROLE_ACCESS = {
  DASHBOARD_STATISTIC_PRODUCTION_COMPONENT: [USER_ROLE.FULL, USER_ROLE.DATA],
  DASHBOARD_STATISTIC_CA_COMPONENT: [USER_ROLE.FULL],
  DASHBOARD_GRAPH_COMPONENT: [USER_ROLE.FULL, USER_ROLE.DATA],
  DASHBOARD_DOCUMENT_LIST_COMPONENT: [USER_ROLE.FULL, USER_ROLE.DOCUMENTATION],
  DOCUMENTS_PAGE: [USER_ROLE.FULL, USER_ROLE.DOCUMENTATION],
  DOWNLOADS_PAGE: [USER_ROLE.FULL, USER_ROLE.DATA],
  MY_POWER_PLANT_PAGE: [USER_ROLE.FULL, USER_ROLE.DATA, USER_ROLE.DOCUMENTATION],
  API_DOCUMENTATION_PAGE: [USER_ROLE.FULL, USER_ROLE.DATA],
}
